// extracted by mini-css-extract-plugin
export var dropdownButton = "_3g-0";
export var fullWidthDropdownButton = "_3g-1";
export var icon = "_3g-3";
export var iconPlaceholder = "_3g-2";
export var menuItemRow = "_3g-5";
export var shortcutContainer = "_3g-4";